import * as noUiSlider from 'nouislider'
import { toNumber, isNil } from 'lodash'
import axios from 'axios'
import { appUrls } from '../config/ajax'
import Qs from 'qs'

const sliderOptions: noUiSlider.Options = {
  start: 0,
  connect: 'lower',
  range: {
    min: 0,
    max: 5,
  },
  step: 0.5,
}

class Review {
  ratingSlider: noUiSlider.target
  ratingValue: HTMLInputElement
  ratingForm: HTMLFormElement
  ratingModule: HTMLDivElement
  ratingResults: HTMLDivElement

  constructor() {
    this.ratingSlider = document.getElementById('ratingSlider') as noUiSlider.target
    this.ratingValue = document.getElementById('ratingValue') as HTMLInputElement
    this.ratingForm = document.getElementById('ratingForm') as HTMLFormElement
    this.ratingModule = document.getElementById('ratingModule') as HTMLDivElement
    this.ratingResults = document.getElementById('ratingResults') as HTMLDivElement

    // noUislider
    if (!isNil(this.ratingSlider)) {
      this.initSlider()
    }

    // form listener
    this.ratingForm.addEventListener('submit', this.onSubmit)
  }

  private initSlider = (): void => {
    noUiSlider.create(this.ratingSlider, sliderOptions)

    this.ratingSlider.noUiSlider.on('update', (newValue) => {
      this.ratingValue.value = String(toNumber(newValue).toFixed(1))
    })
  }

  private onSubmit = (event: SubmitEvent): void => {
    event.preventDefault()
    const userRating = this.ratingValue.value
    const postIdInput = document.getElementsByName('postId')[0] as HTMLInputElement
    this.processUserRating(toNumber(postIdInput.value), userRating)
  }

  private updateUi = (): void => {
    const button = document.getElementById('ratingSubmit') as HTMLButtonElement
    button.disabled = true
    button.innerText = 'Sending'
    this.ratingSlider.noUiSlider.disable()
  }

  private restoreUiAfterError = (): void => {
    const button = document.getElementById('ratingSubmit') as HTMLButtonElement
    if (button) {
      button.disabled = false
      button.innerText = 'Vote'
    }
    if (this.ratingSlider && this.ratingSlider.noUiSlider) {
      this.ratingSlider.noUiSlider.enable()
    }
  }

  private processUserRating = (postId: number, userRating: string): void => {
    this.updateUi()

    const data = {
      action: 'process_rating',
      nonce: WP_AJAX.wpRestNonce,
      userRating: userRating,
      postId: postId,
    }

    // send request
    axios
      .post<
        | string
        | { success: boolean; data?: { message?: string } }
        | { rating_count: number; user_rating: number; html: string }
      >(String(appUrls.ajax), Qs.stringify(data))
      .then((response) => {
        const contentType = response.headers['content-type'] || ''
        const isHtml = contentType.includes('text/html')
        const isJson = contentType.includes('application/json')
        const payload = response.data as any

        // Handle WordPress error JSON
        if (isJson && payload && typeof payload === 'object' && payload.success === false) {
          const code = payload?.data?.message ? String(payload.data.message) : ''
          if (code === 'already_voted') {
            this.ratingModule.innerHTML = '<span class=\"text-white block text-center w-full\">You already voted</span>'
            if (payload?.data?.html) {
              this.ratingResults.innerHTML = String(payload.data.html)
            }
            return
          }
          const msg = code || 'Vote failed'
          this.ratingModule.innerHTML = `<span class=\"text-red block text-center w-full animate-fadeIn\">${msg}</span>`
          this.restoreUiAfterError()
          return
        }

        // Handle standardized success JSON from ReviewRatings
        if (isJson && payload && typeof payload === 'object' && 'html' in payload) {
          this.ratingModule.innerHTML = '<span class=\"text-gold block text-center w-full animate-fadeIn\">Vote Submitted!</span>'
          this.ratingResults.innerHTML = String(payload.html)
          return
        }

        // Fallback: HTML success (older behavior)
        if (isHtml) {
          this.ratingModule.innerHTML = '<span class=\"text-gold block text-center w-full animate-fadeIn\">Vote Submitted!</span>'
          this.ratingResults.innerHTML = String(response.data)
          return
        }

        // Unknown response
        this.ratingModule.innerHTML = '<span class=\"text-red block text-center w-full animate-fadeIn\">Vote failed</span>'
        this.restoreUiAfterError()
      })
      .catch((error) => {
        const newHTML = '<span class="text-red block text-center w-full animate-fadeIn">Something broke.</span>'
        this.ratingModule.innerHTML = newHTML
        this.restoreUiAfterError()
        console.log('error', error)
      })
  }
}

export default Review
